// TODO: Fix Stylelint scales/letter-spacing fake validation warnings
// https://github.com/sketch-hq/Cloud/issues/6722

import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils'

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
`

export const InnerWrapper = styled.div`
  display: grid;
  grid-template-rows: auto;

  padding: 24px 0;
  margin: 24px 0;

  border-top: 1px solid ${({ theme }) => theme.colors.border.dark.base};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
`

export const Item = styled.div<{
  marginBottom?: boolean
  singleColumn?: boolean
}>`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: ${({ singleColumn }) =>
    singleColumn ? 'auto' : '70% 30%'};

  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};

  margin-bottom: ${({ marginBottom }) => (marginBottom ? '16px' : '4px')};

  :last-child {
    margin-bottom: 0;
  }

  > :nth-child(2) {
    text-align: right;
  }
`

export const TrialText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  margin: 0;
`

export const Paragraph = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  letter-spacing: -0.07px; /* stylelint-disable-line scales/letter-spacing */
  line-height: 1.5;

  strong {
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: ${({ theme }) => theme.colors.black};
  }
`

export const StrongText = styled.strong`
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`
export const SmallText = styled.small`
  font-size: ${({ theme }) => theme.fontSizes.little};
`

// Old
export const HalfDivider = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & + & {
    margin-top: 12px;
  }
`

export const Section = styled.div`
  margin-left: 20px;
  padding: 16px 24px 16px 0;

  ${breakpoint('base', 'sm')`
    margin-left: 24px;
    padding-right: 24px;
  `}

  ${Paragraph} {
    &:nth-child(1) {
      margin-top: 0;
    }

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
`
